import { render } from "./whatisthis.vue?vue&type=template&id=6dca83c6&scoped=true"
import script from "./whatisthis.vue?vue&type=script&lang=js"
export * from "./whatisthis.vue?vue&type=script&lang=js"

import "./whatisthis.vue?vue&type=style&index=0&id=6dca83c6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\amaan\\encanto-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dca83c6"]])

export default __exports__